export default "__VITE_ASSET__d995c0d7__"